// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Footer (new) — full site footer
   Sections: top nav grid | mountain scene | dark bottom bar
   All tokens from master.css
   ============================================================ */

.ftr-new {
  background: var(--c-sand);
  overflow: hidden;
}

/* ══════════════════════════════════════════════════════════════
   TOP SECTION
   Grid: brand col | explore | resources | get involved | connect
══════════════════════════════════════════════════════════════ */

.ftr-new__top {
  display: grid;
  grid-template-columns: clamp(200px, 22%, 280px) repeat(3, 1fr) clamp(220px, 24%, 320px);
  gap: 0;
  padding-top: clamp(3rem, 6vw, 5.5rem);
  padding-bottom: clamp(1rem, 2vw, 2rem);
  border-bottom: 1px solid var(--line);
}

/* Brand column */
.ftr-new__brand-col {
  padding-right: clamp(1.5rem, 3vw, 3rem);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  border-right: 1px solid var(--line);
  padding-bottom: clamp(12rem, 25vw, 22rem);
}

.ftr-new__logo-lockup {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.ftr-new__wordmark {
  font-family: var(--font-body);
  font-weight: 900;
  font-size: clamp(1.3rem, 2.2vw, 1.8rem);
  letter-spacing: 0.24em;
  color: var(--c-forest);
  text-transform: uppercase;
  line-height: 1;
}

.ftr-new__brand-rule {
  display: block;
  width: clamp(2rem, 3vw, 2.5rem);
  height: 2px;
  background: var(--accent);
  flex-shrink: 0;
}

.ftr-new__tagline {
  font-family: var(--font-body);
  font-size: clamp(0.82rem, 1vw, 0.92rem);
  color: var(--text-muted);
  line-height: 1.65;
  margin: 0;
  max-width: 22rem;
}

.ftr-new__leaf {
  position: absolute;
  bottom: -2rem;
  left: -70%;
  width: clamp(240px, 30vw, 350px);
  pointer-events: none;
}

.ftr-new__leaf-img {
  width: 100%;
  height: auto;
  display: block;
}

/* Nav columns */
.ftr-new__nav-col {
  padding: 0 clamp(1.25rem, 2.5vw, 2.5rem);
  border-right: 1px solid var(--line);
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.ftr-new__col-heading {
  font-family: var(--font-display);
  font-size: clamp(0.7rem, 1vw, 0.82rem);
  font-weight: 400;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--accent);
  margin: 0;
  line-height: 1;
}

.ftr-new__col-rule {
  display: block;
  width: clamp(1.5rem, 2.5vw, 2rem);
  height: 2px;
  background: var(--accent);
  flex-shrink: 0;
  margin-bottom: 0.25rem;
}

.ftr-new__col-links {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.ftr-new__link {
  font-family: var(--font-body);
  font-size: clamp(0.82rem, 1vw, 0.92rem);
  font-weight: 400;
  color: var(--c-ink);
  text-decoration: none;
  transition: color var(--dur) var(--ease);
  line-height: 1.3;
  display: block;
}
.ftr-new__link:hover {
  color: var(--accent);
}

/* Stay connected column */
.ftr-new__connect-col {
  padding-left: clamp(1.25rem, 2.5vw, 2.5rem);
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.ftr-new__connect-sub {
  font-family: var(--font-body);
  font-size: clamp(0.82rem, 1vw, 0.9rem);
  color: var(--text-muted);
  line-height: 1.6;
  margin: 0;
}

.ftr-new__form {
  margin-top: 0.25rem;
}

.ftr-new__form-row {
  display: flex;
  align-items: stretch;
  border: 1px solid rgba(27, 27, 27, 0.32);
  border-radius: var(--radius-sm);
  overflow: hidden;
  max-width: 22rem;
}

.ftr-new__input {
  flex: 1 1;
  border: none;
  background: transparent;
  padding: 0.82rem 1rem;
  font-family: var(--font-body);
  font-size: 0.88rem;
  color: var(--c-ink);
  outline: none;
  min-width: 0;
}
.ftr-new__input::placeholder {
  color: var(--text-muted);
}

.ftr-new__submit {
  flex-shrink: 0;
  width: 3rem;
  background: var(--accent);
  border: none;
  color: var(--on-accent);
  font-size: 0.82rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background var(--dur) var(--ease);
}
.ftr-new__submit:hover {
  background: var(--accent-hover);
}

.ftr-new__social {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.ftr-new__social-heading {
  font-family: var(--font-display);
  font-size: clamp(0.7rem, 1vw, 0.82rem);
  font-weight: 400;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--accent);
  margin: 0;
}

.ftr-new__social-icons {
  display: flex;
  gap: 0.85rem;
  align-items: center;
}

.ftr-new__social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
  color: var(--c-ink);
  font-size: 1.15rem;
  text-decoration: none;
  transition: color var(--dur) var(--ease);
}
.ftr-new__social-link:hover {
  color: var(--accent);
}

/* ══════════════════════════════════════════════════════════════
   MIDDLE — mountain illustration + stamp
══════════════════════════════════════════════════════════════ */

.ftr-new__mid {
  position: relative;
  width: 100%;

  max-height: clamp(160px, 24vw, 300px);
  display: flex;
  align-items: flex-end;
}

.ftr-new__mountain {
  width: 100%;
  display: flex;
  justify-content: center;
}

.ftr-new__mountain-img {
  width: 100%;
  max-width: 900px;
  height: auto;
  display: block;
  margin-inline: auto;
  margin-bottom: -4px;
}

.ftr-new__stamp-wrap {
  position: absolute;
  bottom: clamp(0.75rem, 2vw, 1.5rem);
  right: clamp(1.5rem, 5vw, 5rem);
  z-index: 2;
  min-width: 20rem;
  border: 3px dashed var(--c-forest);
  rotate: 25deg;
}

/* ══════════════════════════════════════════════════════════════
   DARK BOTTOM BAR
══════════════════════════════════════════════════════════════ */

.ftr-new__bar {
  background: var(--c-forest);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.ftr-new__bar-inner {
  display: grid;
  grid-template-columns: auto 1fr 1fr 1fr 1fr;
  gap: 0;
  align-items: start;
  padding-block: clamp(1.5rem, 3vw, 2.5rem);
}

.ftr-new__bar-badge {
  padding-right: clamp(1.5rem, 3vw, 2.5rem);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
}

.ftr-new__bar-block {
  padding-inline: clamp(1.25rem, 2.5vw, 2rem);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.ftr-new__bar-eyebrow {
  font-family: var(--font-body);
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(220, 204, 180, 0.45);
  margin: 0 0 0.15rem;
}

.ftr-new__bar-location {
  font-size: clamp(1rem, 2vw, 1.5rem);
  color: var(--c-sand);
  margin: 0;
  letter-spacing: 0.06em;
}

.ftr-new__bar-location-sub {
  font-family: var(--font-body);
  font-size: 0.72rem;
  color: rgba(220, 204, 180, 0.55);
  line-height: 1.55;
  margin: 0;
}

.ftr-new__bar-contact {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-body);
  font-size: 0.75rem;
  color: rgba(220, 204, 180, 0.7);
  text-decoration: none;
  transition: color var(--dur) var(--ease);
  line-height: 1.5;
}
.ftr-new__bar-contact:hover {
  color: var(--c-sand);
}
.ftr-new__bar-contact svg {
  font-size: 0.7rem;
  flex-shrink: 0;
}

.ftr-new__bar-legal-link {
  display: block;
  font-family: var(--font-body);
  font-size: 0.75rem;
  color: rgba(220, 204, 180, 0.7);
  text-decoration: none;
  transition: color var(--dur) var(--ease);
  line-height: 1.6;
}
.ftr-new__bar-legal-link:hover {
  color: var(--c-sand);
}

.ftr-new__bar-copy {
  padding-left: clamp(1.25rem, 2.5vw, 2rem);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ftr-new__bar-copy p {
  font-family: var(--font-body);
  font-size: 0.72rem;
  color: rgba(220, 204, 180, 0.55);
  line-height: 1.55;
  margin: 0;
}

.ftr-new__bar-made {
  font-family: var(--font-body);
  font-size: 0.65rem !important;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(220, 204, 180, 0.4) !important;
}

/* ══════════════════════════════════════════════════════════════
   RESPONSIVE
══════════════════════════════════════════════════════════════ */

@media (max-width: 1199.98px) {
  .ftr-new__top {
    grid-template-columns: clamp(180px, 20%, 240px) repeat(3, 1fr) clamp(200px, 22%, 280px);
  }
  .ftr-new__bar-inner {
    grid-template-columns: auto 1fr 1fr;
    grid-template-rows: auto auto;
    row-gap: 1.5rem;
  }
  .ftr-new__bar-copy {
    border-right: none;
  }
}

@media (max-width: 991.98px) {
  .ftr-new__top {
    grid-template-columns: 1fr 1fr;
  }
  .ftr-new__brand-col {
    grid-column: 1 / -1;
    border-right: none;
    border-bottom: 1px solid var(--line);
    padding-bottom: clamp(8rem, 20vw, 16rem);
    padding-right: 0;
  }
  .ftr-new__connect-col {
    grid-column: 1 / -1;
    border-top: 1px solid var(--line);
    padding-left: 0;
    padding-top: clamp(1.25rem, 2.5vw, 2rem);
  }
  .ftr-new__bar-inner {
    grid-template-columns: 1fr 1fr;
  }
  .ftr-new__bar-badge {
    grid-column: 1 / -1;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    justify-content: flex-start;
    padding-bottom: 1rem;
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 767.98px) {
  .ftr-new__top {
    grid-template-columns: 1fr;
  }
  .ftr-new__nav-col {
    border-right: none;
    border-bottom: 1px solid var(--line);
    padding: clamp(1rem, 2vw, 1.5rem) 0;
  }
  .ftr-new__connect-col {
    padding-left: 0;
  }
  .ftr-new__mid {
    max-height: 40vw;
  }
  .ftr-new__stamp-wrap {
    display: none;
  }
  .ftr-new__bar-inner {
    grid-template-columns: 1fr;
  }
  .ftr-new__bar-block {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding-inline: 0;
    padding-block: 0.85rem;
  }
  .ftr-new__bar-copy {
    padding-left: 0;
  }
}

/* ══ 501(c)(3) tax disclosure strip ══════════════════════════
   Full-width row below .ftr-new__bar-inner, still inside the
   dark bar. Separated by a hairline — never in a narrow column.
══════════════════════════════════════════════════════════════ */
.ftr-new__tax-strip {
  display: flex;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap;
  padding-block: 0.85rem 1.1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}

.ftr-new__tax-main {
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: rgba(220, 204, 180, 0.65);
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
}

.ftr-new__tax-divider {
  display: block;
  width: 1px;
  height: 0.8rem;
  background: rgba(220, 204, 180, 0.18);
  flex-shrink: 0;
  align-self: center;
}

.ftr-new__tax-detail {
  font-family: var(--font-body);
  font-size: 0.7rem;
  color: rgba(220, 204, 180, 0.9);
  margin: 0;
  flex: 1 1;
  min-width: 0;
  line-height: 1.5;
}

.ftr-new__tax-detail strong {
  color: rgba(220, 204, 180, 0.9);
  font-weight: 700;
  letter-spacing: 0.04em;
}

.ftr-new__tax-mid {
  margin: 0 0.4rem;
  opacity: 0.45;
}

.ftr-new__tax-link {
  font-family: var(--font-body);
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.07em;
  color: rgba(220, 204, 180, 0.8);
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(220, 204, 180, 0.5);
  padding-bottom: 1px;
  transition:
    color var(--dur, 0.2s) var(--ease, ease),
    border-color var(--dur, 0.2s) var(--ease, ease);
}
.ftr-new__tax-link:hover {
  color: rgba(220, 204, 180, 0.72);
  border-bottom-color: rgba(220, 204, 180, 0.4);
}

@media (max-width: 767.98px) {
  .ftr-new__tax-strip {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.3rem;
  }
  .ftr-new__tax-divider {
    display: none;
  }
  .ftr-new__tax-main {
    white-space: normal;
  }
  .ftr-new__tax-detail {
    white-space: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/Footer.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;gEAGgE;;AAEhE;EACE,aAAa;EACb,uFAAuF;EACvF,MAAM;EACN,qCAAqC;EACrC,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,uCAAuC;EACvC,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,wCAAwC;EACxC,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,wCAAwC;EACxC,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,oBAAoB;AACtB;;AAEA;;gEAEgE;;AAEhE;EACE,kBAAkB;EAClB,WAAW;;EAEX,qCAAqC;EACrC,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;AACf;;AAEA;;gEAEgE;;AAEhE;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,MAAM;EACN,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;;gEAEgE;;AAEhE;EACE;IACE,uFAAuF;EACzF;EACA;IACE,mCAAmC;IACnC,6BAA6B;IAC7B,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,wCAAwC;IACxC,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,iCAAiC;IACjC,eAAe;IACf,wCAAwC;EAC1C;EACA;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,iDAAiD;IACjD,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,mCAAmC;EACrC;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,kDAAkD;IAClD,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;;;gEAGgE;AAChE;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,cAAc;EACd,qCAAqC;EACrC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;EACT,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,iDAAiD;EACjD,mBAAmB;EACnB;;mDAEiD;AACnD;AACA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* ============================================================\n   Footer (new) — full site footer\n   Sections: top nav grid | mountain scene | dark bottom bar\n   All tokens from master.css\n   ============================================================ */\n\n.ftr-new {\n  background: var(--c-sand);\n  overflow: hidden;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   TOP SECTION\n   Grid: brand col | explore | resources | get involved | connect\n══════════════════════════════════════════════════════════════ */\n\n.ftr-new__top {\n  display: grid;\n  grid-template-columns: clamp(200px, 22%, 280px) repeat(3, 1fr) clamp(220px, 24%, 320px);\n  gap: 0;\n  padding-top: clamp(3rem, 6vw, 5.5rem);\n  padding-bottom: clamp(1rem, 2vw, 2rem);\n  border-bottom: 1px solid var(--line);\n}\n\n/* Brand column */\n.ftr-new__brand-col {\n  padding-right: clamp(1.5rem, 3vw, 3rem);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: relative;\n  border-right: 1px solid var(--line);\n  padding-bottom: clamp(12rem, 25vw, 22rem);\n}\n\n.ftr-new__logo-lockup {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.ftr-new__wordmark {\n  font-family: var(--font-body);\n  font-weight: 900;\n  font-size: clamp(1.3rem, 2.2vw, 1.8rem);\n  letter-spacing: 0.24em;\n  color: var(--c-forest);\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n.ftr-new__brand-rule {\n  display: block;\n  width: clamp(2rem, 3vw, 2.5rem);\n  height: 2px;\n  background: var(--accent);\n  flex-shrink: 0;\n}\n\n.ftr-new__tagline {\n  font-family: var(--font-body);\n  font-size: clamp(0.82rem, 1vw, 0.92rem);\n  color: var(--text-muted);\n  line-height: 1.65;\n  margin: 0;\n  max-width: 22rem;\n}\n\n.ftr-new__leaf {\n  position: absolute;\n  bottom: -2rem;\n  left: -70%;\n  width: clamp(240px, 30vw, 350px);\n  pointer-events: none;\n}\n\n.ftr-new__leaf-img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Nav columns */\n.ftr-new__nav-col {\n  padding: 0 clamp(1.25rem, 2.5vw, 2.5rem);\n  border-right: 1px solid var(--line);\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.ftr-new__col-heading {\n  font-family: var(--font-display);\n  font-size: clamp(0.7rem, 1vw, 0.82rem);\n  font-weight: 400;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--accent);\n  margin: 0;\n  line-height: 1;\n}\n\n.ftr-new__col-rule {\n  display: block;\n  width: clamp(1.5rem, 2.5vw, 2rem);\n  height: 2px;\n  background: var(--accent);\n  flex-shrink: 0;\n  margin-bottom: 0.25rem;\n}\n\n.ftr-new__col-links {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.ftr-new__link {\n  font-family: var(--font-body);\n  font-size: clamp(0.82rem, 1vw, 0.92rem);\n  font-weight: 400;\n  color: var(--c-ink);\n  text-decoration: none;\n  transition: color var(--dur) var(--ease);\n  line-height: 1.3;\n  display: block;\n}\n.ftr-new__link:hover {\n  color: var(--accent);\n}\n\n/* Stay connected column */\n.ftr-new__connect-col {\n  padding-left: clamp(1.25rem, 2.5vw, 2.5rem);\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.ftr-new__connect-sub {\n  font-family: var(--font-body);\n  font-size: clamp(0.82rem, 1vw, 0.9rem);\n  color: var(--text-muted);\n  line-height: 1.6;\n  margin: 0;\n}\n\n.ftr-new__form {\n  margin-top: 0.25rem;\n}\n\n.ftr-new__form-row {\n  display: flex;\n  align-items: stretch;\n  border: 1px solid rgba(27, 27, 27, 0.32);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  max-width: 22rem;\n}\n\n.ftr-new__input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  padding: 0.82rem 1rem;\n  font-family: var(--font-body);\n  font-size: 0.88rem;\n  color: var(--c-ink);\n  outline: none;\n  min-width: 0;\n}\n.ftr-new__input::placeholder {\n  color: var(--text-muted);\n}\n\n.ftr-new__submit {\n  flex-shrink: 0;\n  width: 3rem;\n  background: var(--accent);\n  border: none;\n  color: var(--on-accent);\n  font-size: 0.82rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background var(--dur) var(--ease);\n}\n.ftr-new__submit:hover {\n  background: var(--accent-hover);\n}\n\n.ftr-new__social {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.ftr-new__social-heading {\n  font-family: var(--font-display);\n  font-size: clamp(0.7rem, 1vw, 0.82rem);\n  font-weight: 400;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--accent);\n  margin: 0;\n}\n\n.ftr-new__social-icons {\n  display: flex;\n  gap: 0.85rem;\n  align-items: center;\n}\n\n.ftr-new__social-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.2rem;\n  height: 2.2rem;\n  color: var(--c-ink);\n  font-size: 1.15rem;\n  text-decoration: none;\n  transition: color var(--dur) var(--ease);\n}\n.ftr-new__social-link:hover {\n  color: var(--accent);\n}\n\n/* ══════════════════════════════════════════════════════════════\n   MIDDLE — mountain illustration + stamp\n══════════════════════════════════════════════════════════════ */\n\n.ftr-new__mid {\n  position: relative;\n  width: 100%;\n\n  max-height: clamp(160px, 24vw, 300px);\n  display: flex;\n  align-items: flex-end;\n}\n\n.ftr-new__mountain {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.ftr-new__mountain-img {\n  width: 100%;\n  max-width: 900px;\n  height: auto;\n  display: block;\n  margin-inline: auto;\n  margin-bottom: -4px;\n}\n\n.ftr-new__stamp-wrap {\n  position: absolute;\n  bottom: clamp(0.75rem, 2vw, 1.5rem);\n  right: clamp(1.5rem, 5vw, 5rem);\n  z-index: 2;\n  min-width: 20rem;\n  border: 3px dashed var(--c-forest);\n  rotate: 25deg;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   DARK BOTTOM BAR\n══════════════════════════════════════════════════════════════ */\n\n.ftr-new__bar {\n  background: var(--c-forest);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.ftr-new__bar-inner {\n  display: grid;\n  grid-template-columns: auto 1fr 1fr 1fr 1fr;\n  gap: 0;\n  align-items: start;\n  padding-block: clamp(1.5rem, 3vw, 2.5rem);\n}\n\n.ftr-new__bar-badge {\n  padding-right: clamp(1.5rem, 3vw, 2.5rem);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n}\n\n.ftr-new__bar-block {\n  padding-inline: clamp(1.25rem, 2.5vw, 2rem);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.ftr-new__bar-eyebrow {\n  font-family: var(--font-body);\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(220, 204, 180, 0.45);\n  margin: 0 0 0.15rem;\n}\n\n.ftr-new__bar-location {\n  font-size: clamp(1rem, 2vw, 1.5rem);\n  color: var(--c-sand);\n  margin: 0;\n  letter-spacing: 0.06em;\n}\n\n.ftr-new__bar-location-sub {\n  font-family: var(--font-body);\n  font-size: 0.72rem;\n  color: rgba(220, 204, 180, 0.55);\n  line-height: 1.55;\n  margin: 0;\n}\n\n.ftr-new__bar-contact {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: var(--font-body);\n  font-size: 0.75rem;\n  color: rgba(220, 204, 180, 0.7);\n  text-decoration: none;\n  transition: color var(--dur) var(--ease);\n  line-height: 1.5;\n}\n.ftr-new__bar-contact:hover {\n  color: var(--c-sand);\n}\n.ftr-new__bar-contact svg {\n  font-size: 0.7rem;\n  flex-shrink: 0;\n}\n\n.ftr-new__bar-legal-link {\n  display: block;\n  font-family: var(--font-body);\n  font-size: 0.75rem;\n  color: rgba(220, 204, 180, 0.7);\n  text-decoration: none;\n  transition: color var(--dur) var(--ease);\n  line-height: 1.6;\n}\n.ftr-new__bar-legal-link:hover {\n  color: var(--c-sand);\n}\n\n.ftr-new__bar-copy {\n  padding-left: clamp(1.25rem, 2.5vw, 2rem);\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.ftr-new__bar-copy p {\n  font-family: var(--font-body);\n  font-size: 0.72rem;\n  color: rgba(220, 204, 180, 0.55);\n  line-height: 1.55;\n  margin: 0;\n}\n\n.ftr-new__bar-made {\n  font-family: var(--font-body);\n  font-size: 0.65rem !important;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: rgba(220, 204, 180, 0.4) !important;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   RESPONSIVE\n══════════════════════════════════════════════════════════════ */\n\n@media (max-width: 1199.98px) {\n  .ftr-new__top {\n    grid-template-columns: clamp(180px, 20%, 240px) repeat(3, 1fr) clamp(200px, 22%, 280px);\n  }\n  .ftr-new__bar-inner {\n    grid-template-columns: auto 1fr 1fr;\n    grid-template-rows: auto auto;\n    row-gap: 1.5rem;\n  }\n  .ftr-new__bar-copy {\n    border-right: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .ftr-new__top {\n    grid-template-columns: 1fr 1fr;\n  }\n  .ftr-new__brand-col {\n    grid-column: 1 / -1;\n    border-right: none;\n    border-bottom: 1px solid var(--line);\n    padding-bottom: clamp(8rem, 20vw, 16rem);\n    padding-right: 0;\n  }\n  .ftr-new__connect-col {\n    grid-column: 1 / -1;\n    border-top: 1px solid var(--line);\n    padding-left: 0;\n    padding-top: clamp(1.25rem, 2.5vw, 2rem);\n  }\n  .ftr-new__bar-inner {\n    grid-template-columns: 1fr 1fr;\n  }\n  .ftr-new__bar-badge {\n    grid-column: 1 / -1;\n    border-right: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    justify-content: flex-start;\n    padding-bottom: 1rem;\n    margin-bottom: 0.5rem;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .ftr-new__top {\n    grid-template-columns: 1fr;\n  }\n  .ftr-new__nav-col {\n    border-right: none;\n    border-bottom: 1px solid var(--line);\n    padding: clamp(1rem, 2vw, 1.5rem) 0;\n  }\n  .ftr-new__connect-col {\n    padding-left: 0;\n  }\n  .ftr-new__mid {\n    max-height: 40vw;\n  }\n  .ftr-new__stamp-wrap {\n    display: none;\n  }\n  .ftr-new__bar-inner {\n    grid-template-columns: 1fr;\n  }\n  .ftr-new__bar-block {\n    border-right: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    padding-inline: 0;\n    padding-block: 0.85rem;\n  }\n  .ftr-new__bar-copy {\n    padding-left: 0;\n  }\n}\n\n/* ══ 501(c)(3) tax disclosure strip ══════════════════════════\n   Full-width row below .ftr-new__bar-inner, still inside the\n   dark bar. Separated by a hairline — never in a narrow column.\n══════════════════════════════════════════════════════════════ */\n.ftr-new__tax-strip {\n  display: flex;\n  align-items: baseline;\n  gap: 1rem;\n  flex-wrap: wrap;\n  padding-block: 0.85rem 1.1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.ftr-new__tax-main {\n  font-family: var(--font-body);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: rgba(220, 204, 180, 0.65);\n  margin: 0;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.ftr-new__tax-divider {\n  display: block;\n  width: 1px;\n  height: 0.8rem;\n  background: rgba(220, 204, 180, 0.18);\n  flex-shrink: 0;\n  align-self: center;\n}\n\n.ftr-new__tax-detail {\n  font-family: var(--font-body);\n  font-size: 0.7rem;\n  color: rgba(220, 204, 180, 0.9);\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  line-height: 1.5;\n}\n\n.ftr-new__tax-detail strong {\n  color: rgba(220, 204, 180, 0.9);\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.ftr-new__tax-mid {\n  margin: 0 0.4rem;\n  opacity: 0.45;\n}\n\n.ftr-new__tax-link {\n  font-family: var(--font-body);\n  font-size: 0.65rem;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  color: rgba(220, 204, 180, 0.8);\n  text-decoration: none;\n  white-space: nowrap;\n  flex-shrink: 0;\n  border-bottom: 1px solid rgba(220, 204, 180, 0.5);\n  padding-bottom: 1px;\n  transition:\n    color var(--dur, 0.2s) var(--ease, ease),\n    border-color var(--dur, 0.2s) var(--ease, ease);\n}\n.ftr-new__tax-link:hover {\n  color: rgba(220, 204, 180, 0.72);\n  border-bottom-color: rgba(220, 204, 180, 0.4);\n}\n\n@media (max-width: 767.98px) {\n  .ftr-new__tax-strip {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.3rem;\n  }\n  .ftr-new__tax-divider {\n    display: none;\n  }\n  .ftr-new__tax-main {\n    white-space: normal;\n  }\n  .ftr-new__tax-detail {\n    white-space: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
